import { isEmpty } from 'lodash';

import { VisitPatient } from '@dreryk/egabinet-visit-frontend-api';
import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { createTranslatedText, phoneNumberFormatter } from '@dreryk/react-common';
import { LabeledValue, Link } from '@dreryk/react-components';

import {
   getPatientReferenceIdentifierTypeTranslatableText,
   getPatientReferenceIdentifierValueTranslatableText,
} from '~libs.shared.patient';

import { visitTranslationKeys } from '../../../translations';

type VisitHeaderPatientDetailsProps = {
   readonly patient: VisitPatient | PatientSimple;
};

export const VisitHeaderPatientDetails = (props: VisitHeaderPatientDetailsProps): JSX.Element => {
   return (
      <>
         {props.patient.referenceIdentifier ? (
            <LabeledValue
               label={getPatientReferenceIdentifierTypeTranslatableText(props.patient.referenceIdentifier)}
               value={getPatientReferenceIdentifierValueTranslatableText(props.patient.referenceIdentifier)}
               testId={'patientReferenceIdentifier'}
               nowrap
            />
         ) : null}
         <LabeledValue
            label={visitTranslationKeys.patientDetails.age}
            value={createTranslatedText(isEmpty(props.patient.formattedAge) ? '-' : props.patient.formattedAge)}
            testId={'age'}
            nowrap
         />
         <LabeledValue
            label={visitTranslationKeys.patientDetails.phoneAbbreviationUppercase}
            value={
               props.patient.phoneNumber ? (
                  <Link
                     testId={'patientPhoneNumber'}
                     label={createTranslatedText(phoneNumberFormatter(props.patient.phoneNumber)!)}
                  />
               ) : (
                  createTranslatedText('-')
               )
            }
            testId={'phoneNumber'}
            nowrap
         />
      </>
   );
};
